import { customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const LegendPositionRoot = styled.div`
  ${customScrollMinimal};
  overflow-y: scroll;
  max-height: 400px;
  position: absolute;
  left: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
